<template>
  <div>
    <el-row style="margin-bottom: 20px;color: #F56C6C; font-size: 20px; font-weight: bolder">
      <el-col :xl="3" :lg="4" :md="6">
        <span>
          档口：{{ projectToShopCarList.DEPARTMENT_NAME }}
        </span>
      </el-col>
      <el-col :xl="3" :lg="5" :md="6">
        <span>
          日期：{{ projectToShopCarList.ORDER_DATE }}
        </span>
      </el-col>
      <el-col :xl="3" :lg="5" :md="6">
        <el-button size="medium" @click="openChange" :disabled="isDisabled">切换</el-button>
      </el-col>
    </el-row>
    <el-row style="text-align: right">
      <el-col style="margin-bottom: 15px">
        <span>
          总金额：{{ TOTAL_FEE }}
        </span>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-table :data="tableData" stripe border style="width: 100%">
          <el-table-column type="index" label="序号" width="50"></el-table-column>
          <el-table-column prop="PRODUCT_CODE" label="产品编码"></el-table-column>
          <el-table-column prop="PRODUCT_NAME" label="产品" min-width="130"></el-table-column>
          <el-table-column prop="TYPE_UNIT" label="单位" min-width="45"></el-table-column>
          <el-table-column prop="PRODUCT_PRICE" label="单价" min-width="60"></el-table-column>
          <el-table-column prop="OLD_COUNT" label="库存" min-width="80"></el-table-column>
          <el-table-column prop="PRODUCT_COUNT" label="数量" min-width="80"></el-table-column>
          <el-table-column prop="COMMENT" label="备注" min-width="150"></el-table-column>
          <el-table-column fixed="right" label="操作" width="100">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="__deleteProduct(scope.row)">删除</el-button>
              <el-button type="text" size="small" @click="__editProduct(scope.row)">修改</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row style="margin-top:20px;height:100px">
      <el-col :xl="3" :lg="3" :md="5">
        <span>
          总金额：{{ TOTAL_FEE }}
        </span>
      </el-col>
      <el-col :xl="{ span: 1, offset: 16 }" :lg="{ span: 1, offset: 13 }" :md="{ span: 1, offset: 9 }">
        <el-button @click="addProducts()" :disabled="isAddDisabled">新增商品</el-button>
      </el-col>
      <el-col :xl="{ span: 1, offset: 1 }" :lg="{ span: 1, offset: 2 }" :md="{ span: 1, offset: 3 }">
        <el-button @click="__clean()">清空商品</el-button>
      </el-col>
      <el-col :xl="{ span: 1, offset: 1 }" :lg="{ span: 1, offset: 2 }" :md="{ span: 1, offset: 3 }">
        <el-button @click="__order()">确认出库</el-button>
      </el-col>
    </el-row>
    <!-- 修改单品数量 -->
    <el-dialog title="修改商品" :visible.sync="editFormVisible" width="30%" center>
      <el-form :ref="editForm" :model="editForm" label-width="100px" style="text-align: inherit;margin: 0">
        <el-form-item label="领料数量：">
          <el-input v-model="editForm.PRODUCT_COUNT"></el-input>
        </el-form-item>
        <el-form-item label="备注：">
          <el-input v-model="editForm.COMMENT"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editFormVisible = false">取 消</el-button>
        <el-button @click="submitEdit('secondForm')">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 领料人姓名 -->
    <el-dialog title="填写领料人姓名" :visible.sync="peopleFormVisible" width="30%" center>
      <el-form :ref="peopleForm" :model="peopleForm" label-width="100px" style="text-align: inherit;margin: 0">
        <el-form-item label="领料人：">
          <!-- <el-input v-model="peopleForm.NAME"></el-input> -->
          <el-select filterable v-model="peopleForm.NAME" placeholder="请选择领料人" style="width: 100%">
            <el-option v-for="item in peopleList" :key="item.REQUISITIONER" :label="item.REQUISITIONER" :value="item.REQUISITIONER">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="peopleFormVisible = false">取 消</el-button>
        <el-button @click="submitCreate('secondForm')">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 切换领料信息 -->
    <el-dialog title="领料信息" :visible.sync="pickingFormVisible" width="30%" center :close-on-click-modal="false" :show-close="false">
      <el-form :ref="pickingForm" :model="pickingForm" label-width="100px" style="text-align: inherit;margin: 0">
        <el-form-item label="领料日期：">
          <el-date-picker v-model="pickingForm.date" align="right" type="date" placeholder="选择日期" value-format="yyyy-MM-dd"
            :picker-options="pickerOptions1" style="width: 100%" :disabled="isDisabled">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="领料部门：">
          <el-select filterable v-model="pickingForm.dkName" placeholder="请选择档口" style="width: 100%" :disabled="isDisabled">
            <el-option v-for="item in departmentList" :key="item.ID" :label="item.DEPARTMENT_NAME" :value="item.ID">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closePicking">取 消</el-button>
        <el-button @click="submitInfo('secondForm')">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  shopCarDetail, deleteShopDetail, editShopCarFun, clearShopCarFun, createOrder, changeFun,
} from 'api/pickingManage';
import { queryDepartment, queryPeople } from 'api/systemSetting';
import util from '@/assets/common/util';

export default {
  data() {
    return {
      selectValue: '',
      goOnOrderVisible: false,
      TOTAL_FEE: 0.00,
      supplierVisible: false,
      tableData: [],
      supplierData: [],
      purchaserData: [],
      changeCount: {},
      changeComment: {},
      SUPPLIER_IDs: [],
      // 存储档口相关信息
      projectToShopCarList: {},
      // 判断单位是否为KG
      isTypeUnit: '',
      isDisabled: true,
      editFormVisible: false,
      editForm: {},
      CART_ID: 0,
      peopleForm: {},
      peopleFormVisible: false,
      pickingFormVisible: false,
      pickingForm: {},
      departmentList: [],
      pickerOptions1: [],
      peopleList: [],
    };
  },
  created() {
    this.__queryUserManageListData();
    this.queryDepartment();
    this.queryPeople();
  },
  computed: {
    isAddDisabled() {
      return JSON.stringify(this.projectToShopCarList) === '{}';
    },
  },
  methods: {
    // 点击新增商品触发
    addProducts() {
      this.$router.push({ name: 'pickingProduct' });
    },
    __clean() {
      const params = {
        CART_ID: this.CART_ID,
      };
      clearShopCarFun(params).then((result) => {
        this.$message.show({ text: '清空成功', type: 'success' });
        // 初始化数据
        this.tableData = [];
        this.projectToShopCarList = {};
        this.TOTAL_FEE = 0.00;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    skip() {
      this.$router.push({ name: '/ShopCar' });
    },
    //  选择器改变触发事件，e为档口的ID
    loadDataAboutDK(ID) {
      this.selectValue = ID;
    },
    // 获取购物车列表
    __queryUserManageListData() {
      const data = {};
      shopCarDetail(data).then((result) => {
        if (result[0].TITILE.length !== 0) {
          this.CART_ID = result[0].TITILE[0].ID;
          this.projectToShopCarList = JSON.stringify(result[0].TITILE) === '[]' ? {} : result[0].TITILE[0];
          this.TOTAL_FEE = result[0].TOTAL_FEE === '' ? 0.00 : result[0].TOTAL_FEE;
          this.isDisabled = false;
        }
        if (result[1].PRODUCTS_IN_SC.length === 0) {
          this.$message.show({ text: '暂无产品', type: 'warning' });
          this.TOTAL_FEE = 0;
          this.tableData = [];
        } else {
          this.tableData = result[1].PRODUCTS_IN_SC;
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 下单
    __order() {
      if (this.tableData.length == 0) {
        this.$message.show({ text: '购物车为空不能提交', type: 'warning' });
      } else {
        this.peopleFormVisible = true;
      }
    },
    close() {
      this.goOnOrderVisible = false;
    },
    // 删除订单
    __deleteProduct(row) {
      const data = {
        CART_DETAIL_ID: row.ID,
      };
      deleteShopDetail(data).then((result) => {
        this.$message.show({ text: '删除成功', type: 'success' });
        this.__queryUserManageListData();
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 修改产品数量
    __editProduct(row) {
      this.editFormVisible = true;
      this.editForm = row;
    },
    submitEdit() {
      // 正则：正数
      const reg1 = /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/;
      // 正则：正整数(后面可以跟.0000)
      const reg2 = /^\d+(\.0+)?$/;
      if (util.JudgmentUnit(this.editForm.TYPE_UNIT)) {
        if (!reg1.test(this.editForm.PRODUCT_COUNT)) {
          this.$message.show({ text: '请输入正数领料数量', type: 'warning' });
          return false;
        }
      } else if (!reg2.test(this.editForm.PRODUCT_COUNT)) {
        this.$message.show({ text: '请输入正整数领料数量', type: 'warning' });
        return false;
      }
      if (Number(this.editForm.PRODUCT_COUNT > Number(this.editForm.OLD_COUNT))) {
        this.$message.show({ text: '领料数量不得超出库存数量', type: 'warning' });
        return false;
      }
      const params = {
        CART_DETAIL_ID: this.editForm.ID,
        PRODUCT_COUNT: this.editForm.PRODUCT_COUNT,
        PRODUCT_COMMENT: this.editForm.COMMENT,
      };
      editShopCarFun(params).then((res) => {
        this.$message.show({ text: '修改成功', type: 'success' });
        this.editFormVisible = false;
        this.editForm = {};
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 创建订单
    submitCreate() {
      if (document.body.style.cursor === 'wait') {
      } else {
        document.body.style.cursor = 'wait';
        try {
          const params = {
            REQUISITIONER: this.peopleForm.NAME,
          };
          createOrder(params).then((res) => {
            this.$message.show({ text: '下单成功', type: 'success' });
            this.peopleFormVisible = false;
            this.peopleForm = {};
            this.projectToShopCarList = {};
            this.$router.push({ name: 'pickingDoc' });
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
          });
        } finally {
          document.body.style.cursor = 'default';
        }
      }
    },
    queryDepartment() {
      const params = {
        STATUS: 1,
      };
      queryDepartment(params).then((res) => {
        this.departmentList = res;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    submitInfo() {
      const params = {
        CART_ID: this.CART_ID,
        DEPARTMENT_ID: this.pickingForm.dkName,
        ORDER_DATE: this.pickingForm.date,
      };
      changeFun(params).then((result) => {
        this.$message.show({ text: '操作成功', type: 'success' });
        this.pickingFormVisible = false;
        this.__queryUserManageListData();
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    closePicking() {
      this.pickingFormVisible = false;
    },
    openChange() {
      this.pickingFormVisible = true;
    },
    // 拉取所有人员
    queryPeople() {
      const params = {
      };
      queryPeople(params).then((res) => {
        this.peopleList = res;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
  },
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/warehouseManage/pickingShopCar.vue